import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateMfaRequiredSetting as UpdateMfaRequiredSettingMutation,
    UpdateMfaRequiredSettingVariables as UpdateMfaRequiredSettingVariables,
    MfaUpdateRequiredSettingInput,
} from 'nutshell-graphql-types';

import UPDATE_MFA_REQUIRED_SETTINGS from '../mutations/update-mfa-required-setting.graphql';

export const useUpdateMfaRequiredSetting = (): {
    updateMfaRequiredSetting: (arg1: MfaUpdateRequiredSettingInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateMfaRequiredSetting, {loading, error}] = useMutation<
        UpdateMfaRequiredSettingMutation,
        UpdateMfaRequiredSettingVariables
    >(UPDATE_MFA_REQUIRED_SETTINGS);

    return {
        updateMfaRequiredSetting: (input: MfaUpdateRequiredSettingInput) =>
            updateMfaRequiredSetting({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
